// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CMxJUjKk3ll6dapmLeAb {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    min-width: 0;
    width: 100%;
}
.UHLUyuDibA3d9Vr_foRV {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.6rem;
    padding: 1.6rem 0;
    border-bottom: 0.1rem solid var(--mark-border);
}
.IlRYIXnCfbrB0komQFh3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.2rem;
}
.UAjbaf75SVl6RnR_FU6T {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    min-width: 0;
}
.QiIgrjbUSDV4HmDsN9Ok {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    min-width: 0;
    padding: 1.6rem;
}
.YH0tFyrKBg_T6rAFZX_A {
    min-width: 0;
    padding: 1.6rem;
    background: var(--mark-surface);
}
.BImCM4AwV8XshctYJhD6 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.8rem;
    padding-bottom: 0.8rem;
    margin-bottom: 1.2rem;
    border-bottom: 0.1rem solid var(--mark-border);
}
.SZFaNEBoQCxUyN7W0cX8 {
    display: flex;
    flex-wrap: wrap;
    background: var(--mark-surface);
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
    padding: 0.8rem 0;
    border-top: 0.1rem solid var(--mark-border);
}
@media (max-width: 600px) {
    .QiIgrjbUSDV4HmDsN9Ok,
    .YH0tFyrKBg_T6rAFZX_A {
        padding: 1.6rem;
    }
    .UHLUyuDibA3d9Vr_foRV {
        align-items: flex-start;
    }
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/components/BlockEditor/workspace.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,2CAA2C;AAC/C;AACA;IACI;;QAEI,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".workspace {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n    min-width: 0;\n    width: 100%;\n}\n.toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1.6rem;\n    padding: 1.6rem 0;\n    border-bottom: 0.1rem solid var(--mark-border);\n}\n.actions {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 1.2rem;\n}\n.details {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n    min-width: 0;\n}\n.panel {\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n    min-width: 0;\n    padding: 1.6rem;\n}\n.emailCanvas {\n    min-width: 0;\n    padding: 1.6rem;\n    background: var(--mark-surface);\n}\n.canvasHeading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 0.8rem;\n    padding-bottom: 0.8rem;\n    margin-bottom: 1.2rem;\n    border-bottom: 0.1rem solid var(--mark-border);\n}\n.footer {\n    display: flex;\n    flex-wrap: wrap;\n    background: var(--mark-surface);\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.8rem;\n    padding: 0.8rem 0;\n    border-top: 0.1rem solid var(--mark-border);\n}\n@media (max-width: 600px) {\n    .panel,\n    .emailCanvas {\n        padding: 1.6rem;\n    }\n    .toolbar {\n        align-items: flex-start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var workspace = `CMxJUjKk3ll6dapmLeAb`;
export var toolbar = `UHLUyuDibA3d9Vr_foRV`;
export var actions = `IlRYIXnCfbrB0komQFh3`;
export var details = `UAjbaf75SVl6RnR_FU6T`;
export var panel = `QiIgrjbUSDV4HmDsN9Ok`;
export var emailCanvas = `YH0tFyrKBg_T6rAFZX_A`;
export var canvasHeading = `BImCM4AwV8XshctYJhD6`;
export var footer = `SZFaNEBoQCxUyN7W0cX8`;
export default ___CSS_LOADER_EXPORT___;
